'use client';

import { c as _c } from "react/compiler-runtime";
import { Avatar } from '@common/components';
import SvgGrid from '@common/icon/SvgGrid';
import { useCallback, useState } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
import { BREAKPOINTS, ROUTES } from '@/constants';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { useAuthStore } from '@/stores/AuthStore';
import { HeaderActionPopover } from './HeaderActionPopover';
import { ServiceShortcutFullScreenModal } from './ServiceShortcutMenu';
import { ServiceShortcutPopoverContent } from './ServiceShortcutPopoverContent';
const MENU_POPOVER_CONTENT_CLASS = 'w-[330px] overflow-hidden pt-20 pr-[5px]';
const MENU_POPOVER_SCROLL_CLASS = 'max-h-[780px] overflow-y-auto pt-0 pb-20 [&::-webkit-scrollbar]:w-6 [&::-webkit-scrollbar-thumb]:rounded-pill [&::-webkit-scrollbar-thumb]:bg-Gray-300 [&::-webkit-scrollbar-track]:bg-transparent';
interface HeaderProfileAvatarProps {
  showProfileAvatar?: boolean;
}
export const HeaderProfileAvatar = t0 => {
  const $ = _c(17);
  const {
    showProfileAvatar: t1
  } = t0;
  const showProfileAvatar = t1 === undefined ? true : t1;
  const myInfo = useAuthStore(_temp);
  const [menuOpen, setMenuOpen] = useState(false);
  const isMobileTablet = useMediaQuery(BREAKPOINTS.MOBILE_TABLET);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = open => {
      setMenuOpen(open);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const handleMenuChange = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setMenuOpen(false);
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const closeMenu = t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => handleMenuChange(true);
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const openMenu = t4;
  const t5 = isMobileTablet ? openMenu : undefined;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SvgGrid className="size-24" />;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== menuOpen || $[5] !== t5) {
    t7 = <button type="button" aria-label={"\uC804\uCCB4 \uBA54\uB274"} aria-expanded={menuOpen} onClick={t5} className="flex size-40 !w-40 shrink-0 items-center justify-center p-0 text-Gray-700 transition-colors hover:text-Gray-900">{t6}</button>;
    $[4] = menuOpen;
    $[5] = t5;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const menuTriggerButton = t7;
  let t8;
  if ($[7] !== isMobileTablet || $[8] !== menuOpen || $[9] !== menuTriggerButton) {
    t8 = isMobileTablet ? <>{menuTriggerButton}<ServiceShortcutFullScreenModal open={menuOpen} onClose={closeMenu} /></> : <HeaderActionPopover open={menuOpen} onOpenChange={handleMenuChange} contentClassName={MENU_POPOVER_CONTENT_CLASS} maxFloatingHeight={800} trigger={menuTriggerButton}><ServiceShortcutPopoverContent onNavigate={closeMenu} className={MENU_POPOVER_SCROLL_CLASS} /></HeaderActionPopover>;
    $[7] = isMobileTablet;
    $[8] = menuOpen;
    $[9] = menuTriggerButton;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== myInfo?.profileImage || $[12] !== showProfileAvatar) {
    t9 = showProfileAvatar && <CustomLink href={ROUTES.MY.pathname} aria-label={"\uB9C8\uC774\uD398\uC774\uC9C0"} className="flex size-40 shrink-0 items-center justify-center p-0 transition-opacity hover:opacity-80"><Avatar size={32} src={myInfo?.profileImage} alt={"\uB0B4 \uD504\uB85C\uD544"} /></CustomLink>;
    $[11] = myInfo?.profileImage;
    $[12] = showProfileAvatar;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <>{t8}{t9}</>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};
function _temp(state) {
  return state.myInfo;
}